export const account ={
  "Mail": "Foxit Cloud",
  "title": "My Account",
  "submit":"Submit",
  "unSubmit":"Unsubmit",
  "expiredTip": "Your subscription has expired. If you would like to continue using PDF Editor, reactivate your subscription now.",
  "trialTip": "You are currently on your free trial. Subscribe now!",
  "trialExpiredTip": "Your trial has expired. Please subscribe to continue using PDF Editor.",
  "trialExpiredTip_CN": "Your trial has expired. Please subscribe to continue using PDF Editor.<br/>Users in government and enterprise can <a target=\"_blank\" href=\"https://www.foxitsoftware.cn/pdf-editor/online/free-trial/\">apply for free usage</a>.",
  "notActive": "You do not have access to this advanced tool. Please contact an administrator to activate your account.",
  "superAdminNotActiveForSelf": "You do not have access to this advanced tool. Please go to Admin Console and assign a license to yourself.",
  "superAdminNotActive": "The feature you are attempting to use requires a subscription. You can get a free trial for 14 days by clicking <span id=\"superAdminGetTrial\">Get Free Trial</span>.",
  "ok": "OK",
  "goAdminConsole": "Go to Admin Console",
  "notActiveDisableAllTitle": "No license",
  "notActiveDisableAll": "Please contact your admin for assistance.",
  "expiredTipForTeams": "Your subscription has expired, to get a new subscription visit Foxit website.",
  "buy": "Buy",
  "visitSubscription": "For subscription, please visit:",
  "StartFreeTrial": "Start Free Trial",
  "UpgradePlan": "Upgrade Plan",
  "HighRoi": "HIGHEST ROI",
  "EduUpgradePlan": "Choose a Plan To Upgrade",
  "NorUpgradePlan": "Choose a Plan To Get Started",
  "BuyNow": "Buy Now",
  "UpgradeBundleTip":"Gain access to premium features on PDF Editor.",
  "FreemiumUser": "Freemium User",
  "TrialUser": "In Free Trial",
  "TrailLeftTip": "{day} days left in trial",
  "Cancel": "Cancel",
  "PremiumUser": "Premium User",
  "EduPremiumUser": "Education Premium User",
  "SevenTrailTitle": "Start your 7-Day Free Trial",
  "SevenTrailTip": "Get 7 days of unlimited access to all tools. You can cancel anytime before your free trial ends and you won't be charged.",
  "UpgradePlanTip": "Gain access to premium features on PDF Editor Cloud.",
  "EduPlanInclude": "Plans Include",
  "Role1": "Unlimited access to all PDF Editor Cloud features",
  "Role2": "Edit, OCR, Password Protection",
  "Role3": "Realtime Collaboration",
  "Role4": "20GB File Storage",
  "Role5": "5GB File Storage",
  "SecurityLock": "Secure transaction",
  "SecurityLockTitle": "We're serious about protecting your personal information. To ensure your account details are safe, this transaction is encrypted and secure.",
  "Copyright": "2022 © Foxit   Software Incorporated. All rights reserved.",
  "TaxTips": "You might need to pay tax in addition to your order amount.",
  "ChoosePlan": "Choose a payment plan",
  "BilledMonthly": "Monthly",
  "BilledYearly": "Yearly, prepaid",
  "BilledYearMonthly":"Yearly, paid monthly",
  "FoxitStore":"For more product plan, please visit <span id=\"visit_foxit_store_link\">Foxit Store</span>.",
  "TipUpgradeToStore":"Click <span id=\"upgradeToFoxitStore\">here</span> to learn more products from Foxit.",
  "Month": "mo",
  "Year": "year",
  "BillingInformation": "Billing information",
  "FirstName": "First Name",
  "LastName": "Last Name",
  "Email": "Email",
  "NameLicense": "Name of License",
  "CountryRegion": "Country/Region",
  "StateProvince": "State/Province",
  "City": "City",
  "Address": "Address",
  "Zip": "Zip",
  "CompanyName": "Company name",
  "PaymentInformation": "Payment information",
  "CardholderName": "Cardholder's Name",
  "CardNumber": "Card Number",
  "MMYY": "MM / YY",
  "CardVerificationValue": "Card Verification Value",
  "PayCheck": "Enable automatic renewal. You can disable automatic renewals any time in your Foxit Account.",
  "SevenTrailBtn": "Start my Free 7-Day trial!",
  "Tip1": "Your 7-day free trial will start today and end on {time}. Billing automatically starts after free trial ends.",
  "TipMiddle": "Your subscription will automatically renew and you could cancel your plan at any time via <span id=\"goToAccount\">My Account</span>.",
  "BindErr": "Bind card failed. Please check your card.",
  "Tip2": "You might need to pay tax in addition to your order amount.",
  "Processing": "Processing...",
  "ActiveSevenTrail": "Your free 7-day trial is activated!",
  "FreeTrailItem": "Free trial terms",
  "FreeTrailItemTip1": "Billing automatically starts after free trial ends",
  "FreeTrailItemTip2": "Cancel before {time} to avoid getting billed",
  "StartEditor": "Get Started with PDF Editor",
  "FailSevenTrail": "Free trial unavailable!",
  "BackRetry": " Back to Retry",
  "AddNewCard": "Add New Credit Card",
  "UseExistCard": "Use Existed Credit Card",
  "PayNow": "Pay Now",
  "Back": "Back",
  "ConfirmTip": "Confirm order information",
  "PayComplete": "Your payment is completed successfully!",
  "PayFail": "Payment failed!",
  "FailTip": "We were unable to process your payment.",
  "FailTip1": "Please check and try again.",
  "FailWhy": "Why did it fail?",
  "FailWhy1": "The CVC or Expiry Date might wrong.",
  "FailWhy2": "Your bank network might be down.",
  "PleaseEnter": "{tip} is required",
  "PleaseSelect": "{tip} is required",
  "PleaseCard": "Please valid Card number and expiration",
  "PleaseValid": "Please valid {tip}",
  "VATNumber": "VAT Number",
  "ABNNumber": "ABN Number",
  "AustraliaCheck": "I certify that my business is GST registered in Australia.",
  "TeamFreeTrail": "The feature you are attempting to use requires a subscription. For 7-day free trial, please visit: (<span id=\"linkUrl\">{linkUrl}</span>)",
  "TeamUpgrade": "Your subscription has expired, to get a new subscription visit Foxit website. For subscription, please visit: (<span id=\"linkUrl\">{linkUrl}</span>)"
}